// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10UV0","index":"styles_index__2G5EZ"};